import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HomeIcon, BookOpenIcon, CheckSquareIcon, UserIcon, CheckCircle2Icon, ChevronRightIcon, ClockIcon } from 'lucide-react';
// --- Mock Data ---
const RECENT_WINS = [{
  id: 1,
  title: 'Enabled 2FA on Email',
  points: '+25 pts'
}, {
  id: 2,
  title: 'Completed Scam Recognition',
  points: '+50 pts'
}, {
  id: 3,
  title: 'Updated Device Software',
  points: '+15 pts'
}];
export function MemberDashboardPage() {
  const [activeTab, setActiveTab] = useState('Home');
  return <div className="min-h-screen bg-[#f8f8f8] flex flex-col font-sans pb-20" data-id="element-4192">
      {/* Top Bar */}
      <header className="bg-white px-6 py-5 flex items-center justify-between sticky top-0 z-10 shadow-sm" data-id="element-4193">
        <h1 className="text-xl font-bold text-[#1a0647]" data-id="element-4194">
          Good morning, Lois.
        </h1>
        <div className="w-10 h-10 rounded-full bg-[#8528e2] text-white flex items-center justify-center font-bold" data-id="element-4195">
          LB
        </div>
      </header>

      <main className="flex-1 p-6 space-y-8 max-w-md mx-auto w-full" data-id="element-4196">
        {/* Score Section */}
        <div className="flex flex-col items-center text-center pt-4" data-id="element-4197">
          <div className="relative w-40 h-40 mb-6" data-id="element-4198">
            <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100" data-id="element-4199">
              <circle cx="50" cy="50" r="45" fill="none" stroke="#e5e7eb" strokeWidth="8" data-id="element-4200" />
              <motion.circle cx="50" cy="50" r="45" fill="none" stroke="#0EB4CC" strokeWidth="8" strokeLinecap="round" strokeDasharray="282.7" initial={{
              strokeDashoffset: 282.7
            }} animate={{
              strokeDashoffset: 282.7 - 282.7 * 0.412
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} data-id="element-4201" />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-4202">
              <span className="text-4xl font-bold text-[#111111] leading-none" data-id="element-4203">
                412
              </span>
              <span className="text-gray-400 text-xs font-bold mt-1 uppercase tracking-wider" data-id="element-4204">
                / 1000
              </span>
            </div>
          </div>
          <p className="text-gray-600 font-medium" data-id="element-4205">
            You're <span className="text-[#8528e2] font-bold" data-id="element-4206">38 points</span>{' '}
            away from Essential Protection.
          </p>
        </div>

        {/* Next Step Card */}
        <div data-id="element-4207">
          <h2 className="text-lg font-bold text-[#111111] mb-4" data-id="element-4208">
            Your Next Step
          </h2>
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5" data-id="element-4209">
            <div className="flex items-center gap-2 mb-3" data-id="element-4210">
              <span className="bg-[#f0ebf8] text-[#8528e2] text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded" data-id="element-4211">
                Level 1
              </span>
              <div className="flex items-center gap-1 text-xs text-gray-500 font-medium" data-id="element-4212">
                <ClockIcon size={12} data-id="element-4213" />5 mins
              </div>
            </div>
            <h3 className="text-lg font-bold text-[#111111] mb-2 leading-tight" data-id="element-4214">
              Setting up a Password Manager
            </h3>
            <p className="text-sm text-gray-500 mb-5" data-id="element-4215">
              We'll walk you through setting up a password manager so you never
              have to remember a password again.
            </p>
            <button className="w-full bg-[#8528e2] text-white py-3.5 rounded-xl font-bold hover:bg-[#7322c4] transition-colors shadow-sm flex items-center justify-center gap-2" data-id="element-4216">
              Continue
              <ChevronRightIcon size={18} data-id="element-4217" />
            </button>
          </div>
        </div>

        {/* Recent Wins */}
        <div data-id="element-4218">
          <h2 className="text-lg font-bold text-[#111111] mb-4" data-id="element-4219">Recent Wins</h2>
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-4220">
            {RECENT_WINS.map((win, index) => <div key={win.id} className={`flex items-center justify-between p-4 ${index !== RECENT_WINS.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-4221">
                <div className="flex items-center gap-3" data-id="element-4222">
                  <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center shrink-0" data-id="element-4223">
                    <CheckCircle2Icon size={16} className="text-green-500" data-id="element-4224" />
                  </div>
                  <span className="text-sm font-medium text-[#111111]" data-id="element-4225">
                    {win.title}
                  </span>
                </div>
                <span className="text-xs font-bold text-[#0EB4CC] bg-[#0EB4CC]/10 px-2 py-1 rounded" data-id="element-4226">
                  {win.points}
                </span>
              </div>)}
          </div>
        </div>
      </main>

      {/* Mobile Bottom Tab Bar */}
      <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 flex items-center justify-around pb-safe pt-2 px-2 z-20" data-id="element-4227">
        {[{
        name: 'Home',
        icon: HomeIcon
      }, {
        name: 'Actions',
        icon: BookOpenIcon
      }, {
        name: 'Tasks',
        icon: CheckSquareIcon
      }, {
        name: 'Profile',
        icon: UserIcon
      }].map(item => <button key={item.name} onClick={() => setActiveTab(item.name)} className={`flex flex-col items-center p-2 min-w-[64px] ${activeTab === item.name ? 'text-[#8528e2]' : 'text-gray-400'}`} data-id="element-4228">
            <item.icon size={24} className="mb-1" data-id="element-4229" />
            <span className="text-[10px] font-medium" data-id="element-4230">{item.name}</span>
          </button>)}
      </nav>
    </div>;
}